import * as React from 'react';
import { DeviceOverallUploadStatus } from './DeviceOverallUploadStatus';
import { ModalFailure } from '../../misc/ModalFailure';
import { DeviceUploadStatus, UploadStatus } from '../DevicesNewReducer';
import { ModalWarning } from '../../misc/ModalWarning';
import { Device } from '../../misc/api/DeviceLinkApi/Devices';
import * as ReactMarkdown from "react-markdown";

export interface FailureProps {
    explanationText: string;
    devices: Device[];
    deviceStatuses: DeviceUploadStatus[];
    handleClose: () => void;
}

export const Failure = (props: FailureProps) => {
    const partialFail = props.deviceStatuses.filter(s => s.status === UploadStatus.PartialFailed).length > 0;

    return (
        <div id="DeviceReturnFailure">
            <div className="modal-header bg-primary">
                <h3 className="modal-title">Manage Device</h3>
            </div>
            <div className="modal-body">
                {partialFail ?
                    <ModalWarning>
                        <ReactMarkdown>{props.explanationText}</ReactMarkdown>
                        <DeviceOverallUploadStatus
                            devices={props.devices}
                            deviceStatus={props.deviceStatuses}
                        />
                    </ModalWarning>
                    :
                    <ModalFailure>
                        <ReactMarkdown>{props.explanationText}</ReactMarkdown>
                        <DeviceOverallUploadStatus
                            devices={props.devices}
                            deviceStatus={props.deviceStatuses}
                        />
                    </ModalFailure>
                }
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={props.handleClose}>Finish</button>
            </div>
        </div>
    );
}
